module.exports = __webpack_public_path__ + "img/help_dataset_marker.6a489d2b.png";